import {
  TableBody as MuiTableBody,
  TableRow as MuiTableRow,
  TableCell,
} from '@mui/material';
import * as React from 'react';
import { ColumnDefinition } from './ColumnDefinition';
import { Entity } from './Entity';
import TableRow from './TableRow';

interface TableBodyWrapperProps<T extends Entity> {
  visibleData: T[];
  selected: T[];
  handleClick: (event: React.MouseEvent<unknown>, id: number) => void;
  rowsPerPage: number;
  columnDefinitions: ColumnDefinition<T>[];
  page: number;
}

function createEmptyRows(numEmptyRows: number, columns: number) {
  if (numEmptyRows > 0) {
    return (
      <MuiTableRow style={{ height: 33 * numEmptyRows }}>
        <TableCell colSpan={columns} />
      </MuiTableRow>
    );
  } else {
    return null;
  }
}

const TableBody = <T extends Entity>(
  props: React.PropsWithChildren<TableBodyWrapperProps<T>>
) => {
  const { selected, visibleData, columnDefinitions, handleClick, rowsPerPage } =
    props;
  const isSelected = (id: number) =>
    selected.map((item) => item.id).indexOf(id) !== -1;

  const rows = visibleData.map((t) => {
    const isItemSelected = isSelected(t.id);

    return (
      <TableRow
        key={t.id}
        item={t}
        columnDefinitions={columnDefinitions}
        aria-checked={isItemSelected}
        handleClick={(event) => handleClick(event, t.id)}
        selected={isItemSelected}
      />
    );
  });

  const emptyRows = createEmptyRows(
    rowsPerPage - visibleData.length,
    columnDefinitions.length + 1
  );

  return (
    <MuiTableBody>
      {rows}
      {emptyRows}
    </MuiTableBody>
  );
};

export default TableBody;
